
import { post } from 'services/api';

export const getSingleQuote = async (value, productId) => {
  const response = await post('epresis/single-quote', { cp_destino: value, product_id: productId });
  return response;
};

export const getCartQuote = async (value, items) => {
  const response = await post('epresis/quote', { cp_destino: value, products: items.map(({ itemId, quantity, descriptionId }) => ({ itemId, quantity, descriptionId })) });
  return response;
};

export const getTrackingGuide = async (value) => {
  const response = await post('epresis/tracking-guide', { guide_number: value });
  return response;
};